import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { useNavigate, useParams } from 'react-router-dom';
import { getApiErrorMessage } from './helpers/apiErrorMessage';

function OtherUserWishlist() {
    const { userId } = useParams();
    const navigate = useNavigate();
    const [user, setUser] = useState(null);
    const [entries, setEntries] = useState([]);
    const [isPrivate, setIsPrivate] = useState(false);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);

    useEffect(() => {
        const load = async () => {
            setLoading(true);
            setError(null);
            setIsPrivate(false);
            try {
                const userRes = await axios.get(`/api/users/${userId}`);
                setUser(userRes.data);

                try {
                    const wishlistRes = await axios.get(`/api/users/${userId}/wishlist`);
                    setEntries(wishlistRes.data);
                } catch (err) {
                    if (err.response?.status === 403) {
                        setIsPrivate(true);
                        setEntries([]);
                    } else {
                        throw err;
                    }
                }
            } catch (err) {
                setError(getApiErrorMessage(err, 'load this user wishlist'));
            } finally {
                setLoading(false);
            }
        };
        load();
    }, [userId]);

    if (loading) {
        return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">Loading...</div>;
    }

    if (!user) {
        return <div className="min-h-screen bg-gray-900 text-white flex items-center justify-center">User not found</div>;
    }

    return (
        <div className="min-h-screen bg-gray-900 text-white px-6 pb-10">
            {error && (
                <div className="bg-red-900 border-l-4 border-red-600 p-4 m-4 rounded">
                    <div className="flex justify-between items-center">
                        <p className="text-red-200">{error}</p>
                        <button onClick={() => setError(null)} className="text-red-400 hover:text-red-200 text-2xl">×</button>
                    </div>
                </div>
            )}
            <div className="max-w-4xl mx-auto">
                <button onClick={() => navigate(`/profile/${userId}`)} className="text-gray-400 hover:text-white mb-6 flex items-center gap-2 transition">
                    <i className="fas fa-arrow-left"></i> Back to profile
                </button>
                <h1 className="text-3xl font-bold mb-6">{user.username}'s Wishlist</h1>

                {isPrivate ? (
                    <p className="text-gray-400">This user has hidden their wishlist.</p>
                ) : entries.length === 0 ? (
                    <p className="text-gray-400">No wishlist entries yet.</p>
                ) : (
                    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
                        {entries.map((entry) => (
                            <div key={entry.listEntryId} className="bg-gray-800 p-4 rounded-lg flex gap-3 items-center">
                                <img
                                    src={entry.album.albumCover || 'https://placehold.co/75x75'}
                                    alt={entry.album.title}
                                    className="w-12 h-12 rounded object-cover"
                                />
                                <div className="min-w-0">
                                    <p className="text-white font-semibold truncate">{entry.album.title}</p>
                                    <p className="text-gray-400 text-sm truncate">{entry.album.artist}</p>
                                </div>
                            </div>
                        ))}
                    </div>
                )}
            </div>
        </div>
    );
}

export default OtherUserWishlist;
